import { Action } from "@iva/store-utils";
import { IoState } from "#store/types";
import { DatasourceDto } from "#services/pilotService/types";

/**
 * state is in analogy to google guava Service https://github.com/google/guava/wiki/ServiceExplained#using-a-service
 */
export type DatasourceState = {
    data: IoState<DatasourceDto[]>;
};

/** actions */
export enum DatasourceActionTypes {
    LOAD_START = "@@datasource/LOAD_START",
    LOAD_ERROR = "@@datasource/LOAD_ERROR",
    LOAD_SUCCESS = "@@datasource/LOAD_SUCCESS",
}

export type LoadStartAction = Action<DatasourceActionTypes.LOAD_START>;
export type LoadErrorAction = Action<DatasourceActionTypes.LOAD_ERROR>;
export type LoadSuccessAction = Action<
    DatasourceActionTypes.LOAD_SUCCESS,
    DatasourceDto[]
>;

export type DatasourceActions =
    | LoadStartAction
    | LoadErrorAction
    | LoadSuccessAction;
